import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-table',
  template: `
    <ng-container>
      <table class="table mt-4">
        <thead>
          <tr>
            <th *ngFor="let field of tableFields" [ngStyle]="{ width: field.width }">
              {{ field.header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="listInfosSalaire?.length; else noData">
            <tr *ngFor="let salaire of listInfosSalaire; let i = index">
              <td *ngFor="let field of tableFields">
                <ng-container [ngSwitch]="field.field">
                  <ng-container *ngSwitchCase="'index'">
                    {{ (pagination.currentPage - 1) * pagination.itemsPerPage + 1 + i }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'fullName'">
                    {{ salaire?.nom }} {{ salaire?.prenoms }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'actions'">
                    <button class="btn btn-dark" (click)="showDetailsSalaireAgent.emit(salaire)">
                      <i class="ti-pencil-alt"></i>
                    </button>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    {{ salaire[field.field] }}
                  </ng-container>
                </ng-container>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <pagination-controls 
        (pageChange)="pageChange.emit($event)" 
        previousLabel="Précedent" 
        nextLabel="Suivant">
      </pagination-controls>
    </ng-container>

    <ng-template #noData>
      <tr>
        <td class="text-center" colspan="15"> <!-- {{ tableFields.length }} -->
          <span style="font-size: 18px;">Aucun element trouvé</span>
        </td>
      </tr>
    </ng-template>
  `,
})


export class TableComponent {
  @Input() tableFields: any[] = [];
  @Input() listInfosSalaire: any[] = [];
  @Input() pagination: any = {};
  @Output() showDetailsSalaireAgent = new EventEmitter<any>();
  @Output() pageChange = new EventEmitter<any>();


  ngOnChanges(changes: SimpleChanges) {
    if (changes.tableFields) {
      console.log('Table Fields:', this.tableFields);
    }
    if (changes.listInfosSalaire) {
      console.log('List Infos Salaire:', this.listInfosSalaire);
    }
    if (changes.pagination) {
      console.log('Pagination:', this.pagination);
    }
  }

  getItems(analyse: any, tabKey: string) {
    // Logic to filter and return items based on analyse and tabKey
  }

  getIndex(analyse: any, tabKey: string, index: number) {
    // Logic to calculate and return the index of an item
  }

  thousandSeparator(value: number) {
    return value.toLocaleString();
  }

  truncateString(str: string, length: number) {
    // Logic to truncate a string to a specified length
  }

  getStatusClasses(status: string) {
    // Logic to determine CSS classes for different status values
  }

  canEdit(item: any) {
    // Logic to determine if the user can edit an item
  }

  canView(item: any) {
    // Logic to determine if the user can view an item
  }

  showCommentaire(item: any) {
    // Logic to show the full commentaire for an item
  }

  ouvrirOfa(item: any, mode?: string) {
    // Logic to open the OFA (Fiche d'Appréciation) for an item
  }
}